module.exports = __webpack_public_path__ + "static/img/a008.22cd134.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/s/a008.jpg
// module id = qkj8
// module chunks = 0